/* Gagaberry customer love gallery — 2026-10-16 */
(() => {
  function initCustomerLove() {
    const section = document.getElementById('gb-customer-love');
    if (!section || section.dataset.ready) return;
    const dialog = section.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    section.dataset.ready = 'true';
    const stories = [...section.querySelectorAll('.gb-review-story')];
    const image = dialog.querySelector('img');
    const title = dialog.querySelector('h3');
    const counter = dialog.querySelector('.gb-review-counter');
    const gallery = section.querySelector('.gb-review-gallery');
    let index = 0;
    let opener;
    let savedOverflow = '';
    const rtl = getComputedStyle(section).direction === 'rtl';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const toggle = section.querySelector('[data-gb-review-toggle]');
    let userPaused = motion.matches;
    let galleryVisible = false;
    let hovering = false;
    let resumeAfter = 0;
    const syncSlides = initReviewSlides(section, dialog, rtl, motion);
    function updateToggle() {
      if (!toggle) return;
      toggle.textContent = userPaused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    }
    function delayAutoplay() { resumeAfter = Date.now() + 8000; }
    toggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      resumeAfter = 0;
      updateToggle();
    });
    gallery.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovering = true; });
    gallery.addEventListener('pointerleave', () => { hovering = false; });
    gallery.addEventListener('pointerdown', delayAutoplay, { passive: true });
    gallery.addEventListener('wheel', delayAutoplay, { passive: true });
    gallery.addEventListener('keydown', delayAutoplay);
    const observer = new IntersectionObserver(entries => {
      galleryVisible = entries[0].isIntersecting;
      if (galleryVisible) resumeAfter = Date.now() + 4000;
    }, { threshold: 0.15 });
    observer.observe(gallery);
    const autoplayTimer = setInterval(() => {
      if (!section.isConnected) {
        clearInterval(autoplayTimer);
        observer.disconnect();
        return;
      }
      if (!toggle || userPaused || !galleryVisible || hovering || dialog.open || document.hidden || Date.now() < resumeAfter || gallery.contains(document.activeElement)) return;
      const max = gallery.scrollWidth - gallery.clientWidth;
      if (max <= 1) return;
      const current = Math.abs(gallery.scrollLeft);
      const step = stories.length > 1 ? Math.abs(stories[1].offsetLeft - stories[0].offsetLeft) : gallery.clientWidth;
      const next = current >= max - 2 ? 0 : Math.min(max, current + step);
      gallery.scrollTo({ left: (rtl ? -1 : 1) * next, behavior: motion.matches ? 'auto' : 'smooth' });
    }, 4000);
    motion.addEventListener('change', () => {
      if (motion.matches) { userPaused = true; updateToggle(); }
    });
    updateToggle();
    function show(next) {
      index = (next + stories.length) % stories.length;
      const story = stories[index];
      image.src = story.href;
      image.alt = story.dataset.gbReviewTitle;
      title.textContent = story.dataset.gbReviewTitle;
      counter.textContent = `${index + 1} ${dialog.dataset.gbReviewOf} ${stories.length}`;
    }
    section.addEventListener('click', event => {
      const link = event.target.closest('[data-gb-review-open]');
      if (!link) return;
      event.preventDefault();
      opener = link;
      show(Number(link.dataset.gbReviewOpen));
      savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      dialog.querySelector('.gb-review-close').focus();
      syncSlides();
    });
    dialog.querySelector('.gb-review-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = savedOverflow;
      image.removeAttribute('src');
      opener?.focus({ preventScroll: true });
      syncSlides();
    });
    dialog.querySelectorAll('[data-gb-review-step]').forEach(button => {
      button.addEventListener('click', () => show(index + Number(button.dataset.gbReviewStep)));
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
      }
    });
    section.querySelector('.gb-review-controls').hidden = false;
    section.querySelectorAll('[data-gb-review-scroll]').forEach(button => {
      button.addEventListener('click', () => {
        delayAutoplay();
        gallery.scrollBy({ left: (rtl ? -1 : 1) * Number(button.dataset.gbReviewScroll) * gallery.clientWidth * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  }
  /* 2026-10-17: review slideshow — one review at a time; the progress line's end moves to the next one */
  function initReviewSlides(section, dialog, rtl, motion) {
    const rv = section.querySelector('.gb-rv');
    const slides = rv ? [...rv.querySelectorAll('.gb-rv-slide')] : [];
    if (slides.length < 2) return () => {};
    const track = rv.querySelector('.gb-rv-track');
    const bar = rv.querySelector('.gb-rv-progress span');
    const count = rv.querySelector('.gb-rv-count');
    const toggle = rv.querySelector('[data-gb-rv-toggle]');
    const pad = n => String(n).padStart(2, '0');
    let current = 0;
    let paused = motion.matches;
    let hovering = false;
    let keyboardFocus = false;
    let visible = false;
    const dots = slides.map((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `${i + 1} ${dialog.dataset.gbReviewOf} ${slides.length}`);
      dot.addEventListener('click', () => go(i));
      rv.querySelector('.gb-rv-dots').appendChild(dot);
      return dot;
    });
    function go(next) {
      current = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', String(i !== current));
        slide.inert = i !== current;
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
      count.textContent = `${pad(current + 1)} / ${pad(slides.length)}`;
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
    }
    function sync() {
      rv.classList.toggle('is-playing', !paused);
      rv.classList.toggle('is-held', hovering || keyboardFocus || !visible || dialog.open || document.hidden);
      toggle.textContent = paused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      track.setAttribute('aria-live', paused ? 'polite' : 'off');
    }
    bar.addEventListener('animationend', () => go(current + 1));
    toggle.addEventListener('click', () => { paused = !paused; sync(); });
    rv.querySelectorAll('[data-gb-rv-step]').forEach(button => {
      button.addEventListener('click', () => go(current + Number(button.dataset.gbRvStep)));
    });
    rv.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; sync(); } });
    rv.addEventListener('pointerleave', () => { hovering = false; sync(); });
    rv.addEventListener('focusin', event => { keyboardFocus = event.target.matches(':focus-visible'); sync(); });
    rv.addEventListener('focusout', event => { if (!rv.contains(event.relatedTarget)) { keyboardFocus = false; sync(); } });
    rv.addEventListener('keydown', event => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      go(current + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
    });
    let startX = null;
    let startY = 0;
    track.addEventListener('touchstart', event => { startX = event.touches[0].clientX; startY = event.touches[0].clientY; }, { passive: true });
    track.addEventListener('touchend', event => {
      if (startX === null) return;
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(current + ((dx < 0) !== rtl ? 1 : -1));
    }, { passive: true });
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0.35 }).observe(rv);
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', () => { if (motion.matches) { paused = true; sync(); } });
    rv.querySelector('.gb-rv-nav').hidden = false;
    go(0);
    sync();
    return sync;
  }
  initCustomerLove();
  document.addEventListener('shopify:section:load', initCustomerLove);
})();
